// Authentication Hooks
import { useEffect } from "react"
import * as locCon from "../LocalConstants"
import { isNullOrUndefined } from "../community-hats-js-library/utils/generalFunctions.js"
import { differenceInMinutes, formatISO } from "date-fns"
import { getStoredValue, setStoredValue, StateStoredValue } from "./GeneralStoreHooks"
import { getApiToken } from "../utils/apiTokenFunctions"

export const checkIsLoggedIn = () => {


    const lastInteraction = getStoredValue(locCon.LAST_INTERACTION)

    if (isNullOrUndefined(lastInteraction))
        return false

    return differenceInMinutes(new Date(), new Date(lastInteraction)) < locCon.MAX_IDLE_MINUTES
}

// The session slides: an active user stays logged in indefinitely, so the
// token minted at log in has to be replaced before it expires underneath them.
// Throttled, because the interaction below fires on every click and the token
// only needs to be newer than MAX_IDLE_MINUTES.
const REFRESH_TOKEN_EVERY_MS = 5 * 60 * 1000

let lastTokenRefresh = 0

const refreshAppToken = async () => {

    const token = getStoredValue(locCon.APP_TOKEN)

    if (isNullOrUndefined(token))
        return

    try {
        const response = await fetch('/.netlify/functions/refreshToken', {
            method: 'POST',
            headers: { 'x-app-token': token },
        })

        // Nothing to do on a refusal. The token is either already expired or
        // about to be, and the idle check logs the user out on its own.
        if (!response.ok)
            return

        const { token: newToken } = await response.json()
        setStoredValue(locCon.APP_TOKEN, newToken)
    } catch (error) {
        console.log(`Could not refresh the session token: ${error.message}`)
    }
}

const updateUserInteraction = () => {
    setStoredValue(locCon.LAST_INTERACTION, formatISO(new Date()))

    if (Date.now() - lastTokenRefresh > REFRESH_TOKEN_EVERY_MS) {
        lastTokenRefresh = Date.now()
        refreshAppToken()
        // Renews only when it is close to expiring, so this is a no op almost
        // every time. Riding the same throttle keeps the two tokens on one
        // schedule and adds no timer of its own.
        getApiToken()
    }
}




export const RefIsLoggedIn = () => {
    const [isLoggedIn, setIsLoggedIn] = StateStoredValue(locCon.IS_LOGGED_IN)


    // Checks every minute
    useEffect(() => {
        // Function to run every minute
        const runEveryMinute = () => {
            setIsLoggedIn(checkIsLoggedIn())
        };

        // Set the interval to run every 60,000 ms (1 minute)
        const intervalId = setInterval(runEveryMinute, 60000);

        // Cleanup the interval when the component is unmounted
        return () => clearInterval(intervalId);
    }, [setIsLoggedIn]); // Empty dependency array means this effect runs once when the component mounts


    // Inactivity Check
    useEffect(() => {

        window.addEventListener('click', updateUserInteraction);
        //window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('click', updateUserInteraction);
            //window.removeEventListener('beforeunload', handleBeforeUnload);
        }
    }, [])

    return isLoggedIn


}